import React from "react";
import { useNavigate } from "react-router-dom";

const s = {
  wrapper: {
    minHeight: "70vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },

  card: {
    width: "100%",
    maxWidth: 460,
    background: "#fff",
    borderRadius: 14,
    padding: "36px 28px",
    textAlign: "center",
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
    border: "1px solid #f1f5f9",
  },

  code: {
    fontSize: 44,
    fontWeight: 800,
    color: "#534AB7",
    marginBottom: 8,
  },

  title: {
    fontSize: 22,
    fontWeight: 700,
    color: "#1e293b",
    marginBottom: 10,
  },

  text: {
    fontSize: 14,
    color: "#64748b",
    marginBottom: 24,
    lineHeight: 1.6,
  },

  btn: {
    padding: "10px 18px",
    background: "#534AB7",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600,
  },
};

export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div style={s.wrapper}>
      <div style={s.card}>
        <div style={s.code}>403</div>
        <h1 style={s.title}>Unauthorized Access</h1>
        <p style={s.text}>
          You are not authorized to view this page. Please contact your admin if
          you think this is a mistake.
        </p>
      </div>
    </div>
  );
}
